<template>
  <div class="card">
    <h2 class="title">上传投保资料</h2>
    <div class="content">
      <div class="flex _between">
        <div class="file-list">
          <a-button type="primary" @click="downloadOnce" :loading="downloadLoading">一键下载投保资料电子版</a-button>
          <div v-for="item in downloadList" :key="item.fileName">
            <a @click="downfile(item)" :download="item.fileName">{{item.fileName}}</a>
          </div>
        </div>
        <div class="file-list">
          <a-button type="primary" @click="openUpload">一键上传投保资料盖章版</a-button>
          <div v-for="(item, index) in allFiles" :key="item.fileName" class="flex _between">
            <a :href="item.url" target="_blank">{{item.fileName}}</a>
            <a-button @click="deleteFile(item, index)" type="link" size="small" icon="delete"></a-button>
          </div>
        </div>
      </div>
    </div>
    <a-modal
        class="form-layout" :mask-closable="false"
        :visible="isUploadFileShow" :title="''" :footer="null"
        width="500px" @cancel="isUploadFileShow = false"
    >
        <a-upload-dragger
            :file-list="fileList"
            name="file"
            :multiple="true"
            action="/"
            :remove="handleRemove"
            :beforeUpload="beforeUpload"
        >
            <p>拖动文件到该区域或点击上传文件</p>
        </a-upload-dragger>
        <div class="upload-btns">
            <a-button type="primary" ghost @click="isUploadFileShow = false">取消</a-button>
            <a-button type="primary" @click="uploadSubmit" :disabled="!fileList || !fileList.length">确定上传</a-button>
        </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    files: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      downloadLoading: false,
      isUploadFileShow: false,
      dbFiles: [
        { fileName: "投保单.xlsx", url: "https://image.ssish.com/static/product/MedilinkGroupZRY/dubang/投保单.xlsx"},
        { fileName: "个人健康告知.pdf", url: "https://image.ssish.com/static/product/MedilinkGroupZRY/dubang/个人健康告知.pdf"},
        { fileName: "关联企业投保及发票说明.doc", url: "https://image.ssish.com/static/product/MedilinkGroupZRY/dubang/关联企业投保及发票说明.doc"},
        { fileName: "投保材料填写指引.doc", url: "https://image.ssish.com/static/product/MedilinkGroupZRY/dubang/投保材料填写指引.doc"},
      ],
      rbFiles: [
        { fileName: "投保单.xlsx", url: "https://image.ssish.com/static/product/MedilinkGroupZRY/renbao/投保单.xlsx"},
        { fileName: "个人健康告知.pdf", url: "https://image.ssish.com/static/product/MedilinkGroupZRY/renbao/个人健康告知.pdf"},
        { fileName: "关联企业投保及发票说明.doc", url: "https://image.ssish.com/static/product/MedilinkGroupZRY/renbao/关联企业投保及发票说明.doc"},
        { fileName: "投保材料填写指引.doc", url: "https://image.ssish.com/static/product/MedilinkGroupZRY/renbao/投保材料填写指引.doc"},
        { fileName: "保费超过20万时需提供非自然人客户信息登记表.doc", url: "https://image.ssish.com/static/product/MedilinkGroupZRY/renbao/保费超过20万时需提供非自然人客户信息登记表.doc" },
      ],
      allFiles: [],
      fileList: []
    }
  },
  computed: {
    downloadList() {
      let file = this.files.downloadFiles || []
      if(this.baseInfo.comp === '0') {
        file = file.concat(this.dbFiles)
      } else {
        file = file.concat(this.rbFiles)
      }
      return file;
    }
  },
  watch: {
    "files.uploadedFiles"() {
      this.allFiles = this.files.uploadedFiles || []
    }
  },
  mounted() {
    this.allFiles = this.files.uploadedFiles || []
  },
  methods: {
    // 一键下载
    downloadOnce() {
      this.downloadLoading = true;
      this.$api.downFilesForzip(this.downloadList).then(res => {
        this.downloadFile(res);
      }).finally(() => {
        this.downloadLoading = false;
      })
    },
    // 下载文件
    downfile(data) {
      if(!data.url) {
        return;
      }
      window.open(data.url, "_blank")
    },
    // 打开文件上传弹窗
    openUpload() {
        this.fileList = []
        this.isUploadFileShow = true
    },
    // 收集文件数据 取消自动上传
    beforeUpload(file) {
        this.fileList = [...this.fileList, file];
        return false;
    },
    // 删除已上传的文件
    deleteFile(file, index) {
      const path = 'TaMedilinkGroup/' + file.url.split("/TaMedilinkGroup/")[1]
      const params = {
        quotationId: this.baseInfo.id,
        path,
        // url: file.url
      }
      this.$api.delUploadFile(params).then(res => {
        const data = res.data || {}
        if(data.returnCode === '00') {
          this.allFiles.splice(index, 1);
          this.$message.success(data.returnMsg || "删除文件成功");
        } else {
          this.$message.error(data.returnMsg || "删除文件失败");
        }
      })
    },
    // 移除选择的文件
    handleRemove(file){
      for(let i = 0; i< this.fileList.length; i ++) {
          if (this.fileList[i].uid === file.uid) {
              this.fileList.splice(i, 1)
              return true
          }
      }
    },
    // 点击确定上传按钮
    uploadSubmit() {
        for(let i = 0; i < this.fileList.length; i ++) {
            let formData = new FormData()
            formData.append('fileStream', this.fileList[i])
            formData.append('inquiryInformation', this.baseInfo.inquiryInformation)
            formData.append('fileName', this.fileList[i].name)
            formData.append('fileType', 'tiananTeamUploads')
            this._uploadGroupAFP(formData, this.fileList[i].name)
        }
        this.handleCancel()
    },
    // 关闭弹窗
    handleCancel() {
        this.isUploadFileShow = false
    },
    // 上传文件接口
    _uploadGroupAFP(data, fileName) {
        this.$api.uploadGroupAFP(data).then(res => {
            if (res.data.returnCode === '00') {
                this.allFiles.push(
                  {
                      fileName: fileName,
                      url: res.data.content
                  }
                )
            }
        })
    },
    /**
      * @description 文件下载（兼容IE）
      * @param {Object} response options 接口响应的数据 包括文件流及保文信息
      * @param {String} file_name 文件名称
      * @returns {undefined} undefined
      */
    downloadFile(response, file_name, fileType) {
      fileType = fileType || response.headers["content-type"] || "application/pdf";
      const disposition = response.headers["content-disposition"]
      console.log(fileType)
      if (!file_name) {
        file_name = disposition.split("filename=")[1]
      }
      const blob = new Blob([response.data], { type: `${fileType};charset=utf-8` });

      const ie = navigator.userAgent.match(/MSIE\s([\d.]+)/),
        ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/),
        ieEDGE = navigator.userAgent.match(/Edge/g),
        ieVer = ie ? ie[1] : ie11 ? 11 : ieEDGE ? 12 : -1;

      if (ie && ieVer < 10) {
        new Error('No blobs on IE<10');
        return;
      }
      if (ieVer > -1) {
        window.navigator.msSaveBlob(blob, file_name);
        return {}
      } else {
        const url = window.URL.createObjectURL(blob);

        let link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', file_name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.file-list{
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  padding: 0 20px;
  font-weight: bold;
}
._between{
  justify-content: space-between;
  align-items: flex-start;
}
.btns {
  min-width: 60px;
  ::v-deep .ant-btn{
    margin: 0 20px;
  }
}
::v-deep .ant-upload{
    min-height: 120px;
    margin-top: 20px;
}
.upload-btns{
    text-align: center;
    .ant-btn{
        margin: 20px 10px 0;
    }
}
</style>